<template>
<div id="app">
    <Navbar/>
    <main>
        <router-view/>
    </main>
    <Footer/>
    </div>
</template>
<script>import Navbar from '@/components/layout/Navbar.vue'; import Footer from '@/components/layout/Footer.vue'; export default { name:'App', components:{Navbar,Footer} }</script>
